import { render } from "./NotificationsButton.vue?vue&type=template&id=550bbb0b"
import script from "./NotificationsButton.vue?vue&type=script&lang=js"
export * from "./NotificationsButton.vue?vue&type=script&lang=js"

import "./NotificationsButton.vue?vue&type=style&index=0&id=550bbb0b&lang=css"

import exportComponent from "/home/forge/members.eena.org/releases/81761477/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__